module.exports = __webpack_public_path__ + "static/img/pirate-economy-trade.c8ae195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timeline/pirate-economy-trade.jpg
// module id = 228
// module chunks = 0